import { render, staticRenderFns } from "./receive-physical.vue?vue&type=template&id=06642056&"
import script from "./receive-physical.vue?vue&type=script&lang=ts&"
export * from "./receive-physical.vue?vue&type=script&lang=ts&"
import style0 from "./receive-physical.vue?vue&type=style&index=0&id=06642056&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports